import { createContext } from 'react'

interface IOverlay {
  active: boolean
  setActive: (state: boolean) => void
}

const OverlayContext = createContext<IOverlay>({
  active: false,
  setActive: () => {},
})

export default OverlayContext
